import { defineMessages } from 'react-intl';

const messages = defineMessages({
  stepTitle: {
    id: 'registration.createAgcoId.stepTitle',
    defaultMessage: 'Create your AGCO ID',
    description: 'Registration create AGCO ID step title',
  },
  title: {
    id: 'registration.createAgcoId.title',
    defaultMessage: 'Create an AGCO ID',
    description: 'Registration create AGCO ID title',
  },
  validationCode: {
    id: 'registration.createAgcoId.validationCode',
    defaultMessage: 'Validation code',
    description: 'Registration validation code',
  },
  getValidationCode: {
    id: 'registration.createAgcoId.getValidationCode',
    defaultMessage: 'Get validation code',
    description: 'Registration createAgcoId get validation code',
  },
  sendNewCodeLabel: {
    id: 'registration.createAgcoId.sendNewCode',
    defaultMessage: 'Send new code',
    description: 'Registration createAgcoId send new code label',
  },
  emailValidationErrorMessage: {
    id: 'registration.createAgcoId.emailValidationErrorMessage',
    defaultMessage: 'Please enter a valid email address',
    description: 'Registration createAgcoId email validation error message',
  },
  description: {
    id: 'registration.createAgcoId.description',
    defaultMessage:
      'Start turning your ideas into reality. To log into Customer Experience Platform, you need an AGCO ID.{lineBreak}{lineBreak}Create an AGCO ID and get full access to all products and features. Get started in 2 minutes.{lineBreak}{lineBreak}Enter your email here and we will send you a verification code.',
    description: 'Registration createAgcoId step description',
  },
  verifyTitle: {
    id: 'registration.createAgcoId.verifyTitle',
    defaultMessage: 'Verify your email',
    description: 'Registration createAgcoId verify title',
  },
  verifyDescription: {
    id: 'registration.createAgcoId.verifyDescription',
    defaultMessage: 'Verification code has been sent to your inbox. Please copy it to the input box below.',
    description: 'Registration createAgcoId verify description',
  },
  verifyErrorMessage: {
    id: 'registration.createAgcoId.verifyErrorMessage',
    defaultMessage: 'The verification code is invalid or expired. Please request a new code.',
    description: 'Registration createAgcoId verify error message',
  },
  verifyCodeSent: {
    id: 'registration.createAgcoId.verifyCodeSent',
    defaultMessage:
      'A new verification code has been sent to your mailbox. Please copy it to the input box below. It will expire in 5 minutes.',
    description: 'Registration createAgcoId verify code sent',
  },
  emailAlreadyUsed: {
    id: 'registration.createAgcoId.emailAlreadyUsed',
    defaultMessage: 'This email address is already registered. Please try to login!',
    description: 'Registration createAgcoId email already used',
  },
  registerBusinessHint: {
    id: 'registration.createAgcoId.registerBusinessHint',
    defaultMessage: 'If you would like to register a second business, please use a different email.',
    description: 'Registration createAgcoId register an other business hint',
  },
  redirectionModalTitle: {
    id: 'registration.createAgcoId.redirectionModalTitle',
    defaultMessage: 'Welcome to the FendtONE offboard self-registration process',
    description: 'Registration flow welcome modal title',
  },
  redirectionModalDescription: {
    id: 'registration.createAgcoId.redirectionModalDescription',
    defaultMessage: 'You have been redirected to the general AGCO page to start your registration.',
    description: 'Registration flow welcome modal description',
  },
  redirectionNewCepModalTitle: {
    id: 'registration.createAgcoId.redirectionNewCepModalTitle',
    defaultMessage: 'Welcome to the {productName} self-registration process',
    description: 'Registration flow new CEP welcome modal title',
  },
});

export default messages;
